import { Typography } from 'antd';
import { TextProps } from 'antd/lib/typography/Text';
import _ from 'lodash';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

const Text = Typography.Text;

interface IParagraph extends TextProps {
    text: string;
    disableEdit?: boolean;
    translateParams?: (string | number)[];
}

const Paragraph: React.FC<IParagraph> = props => {
    return (
        // <Text {...props}>
        <Text {..._.omit(props, ['disableEdit'])}>
            <TranslateText disableEdit={props.disableEdit} params={props.translateParams}>
                {props.text}
            </TranslateText>
        </Text>
    );
};

export default Paragraph;
